import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectMarginTarget } from "models/project-margin-target";

export interface AdminProjectMarginTargetsSliceState {
    targets: ProjectMarginTarget[];
    editingTarget: ProjectMarginTarget | null;
}

export const initialState: AdminProjectMarginTargetsSliceState = {
    targets: [],
    editingTarget: null,
};

const byYearDesc = (a: ProjectMarginTarget, b: ProjectMarginTarget) => b.fiscalYear - a.fiscalYear;

const AdminProjectMarginTargetsSlice = createSlice({
    name: "admin-project-margin-targets-slice",
    initialState,
    reducers: {
        setTargets(state, { payload }: PayloadAction<ProjectMarginTarget[]>) {
            state.targets = [...payload].sort(byYearDesc);
        },
        addTarget(state, { payload }: PayloadAction<ProjectMarginTarget>) {
            state.targets = [payload, ...state.targets].sort(byYearDesc);
        },
        setTarget(state, { payload }: PayloadAction<ProjectMarginTarget>) {
            const index = state.targets.findIndex(t => t.id === payload.id);
            if (index !== -1) state.targets[index] = payload;
            state.targets.sort(byYearDesc);
        },
        removeTarget(state, { payload: id }: PayloadAction<string>) {
            state.targets = state.targets.filter(t => t.id !== id);
        },
        setEditingTarget(state, { payload }: PayloadAction<ProjectMarginTarget | null>) {
            state.editingTarget = payload;
        },
    },
});

export const { setTargets, addTarget, setTarget, removeTarget, setEditingTarget } = AdminProjectMarginTargetsSlice.actions;

export default AdminProjectMarginTargetsSlice.reducer;
